// Thin echarts-for-react wrapper.
//
// echarts-for-react accepts an `option` object — same shape as
// echarts4r's underlying config on the R side. That means chart specs
// are portable: an option object defined in TS here can be replicated
// in R, and vice versa. When charts move between languages (e.g.
// rewriting a Lorenz from R to TS), the spec doesn't have to.
//
// We use the `react-core` import path so the bundle only includes the
// chart types it needs (lazy renderer registration would be even
// better — follow-up if bundle size grows).

import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts";

interface Props {
  option: EChartsOption;
  height?: string;
  style?: React.CSSProperties;
  className?: string;
  /** When true (default), the new option replaces the old one entirely
   *  on every render — echarts re-inits the chart, including axes.
   *  Fine for output charts that update once per Simulate. For inputs
   *  driven by a continuous slider, set this to false so echarts
   *  diff-updates and keeps the axis layout stable across ticks. */
  notMerge?: boolean;
  /** When true, echarts batches option updates within a single
   *  animation frame. Pairs naturally with notMerge=false for
   *  slider-driven charts. */
  lazyUpdate?: boolean;
}

export function Chart({
  option,
  height = "320px",
  style,
  className,
  notMerge = true,
  lazyUpdate = false,
}: Props): JSX.Element {
  return (
    <ReactECharts
      option={option}
      style={{ height, width: "100%", ...style }}
      className={className}
      opts={{ renderer: "canvas" }}
      notMerge={notMerge}
      lazyUpdate={lazyUpdate}
    />
  );
}
